module.exports = __webpack_public_path__ + "static/the-road-home-abd187e06295cbe23ef64afc3d457102.jpg";